import { render, staticRenderFns } from "./preview-online.vue?vue&type=template&id=7f0afa12&scoped=true"
import script from "./preview-online.vue?vue&type=script&lang=js"
export * from "./preview-online.vue?vue&type=script&lang=js"
import style0 from "./preview-online.vue?vue&type=style&index=0&id=7f0afa12&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0afa12",
  null
  
)

export default component.exports